// This file is automatically generated. Do not edit manually.

import { SafetyControlSurveyState } from "src/api/generated/erp/db/types/enums/safetyControlSurveyState";
import { SafetyControlSurveyType } from "src/api/generated/erp/db/types/enums/safetyControlSurveyType";
import { SafetyControlSurveyView } from "src/api/generated/erp/db/types/tables/safetyControlSurveyView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SafetyControlSurveyQueryApi {
	export async function getSurveys(args: {
		states: Array<SafetyControlSurveyState>;
		surveyType?: SafetyControlSurveyType | null | undefined;
		searchQuery?: string;
	}): Promise<Array<SafetyControlSurveyView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveys/getSurveys",
			method: "POST",
			data: {
				states: args.states,
				surveyType: args.surveyType,
				searchQuery: args.searchQuery,
			},
		});
		return response as Array<SafetyControlSurveyView>;
	}

	export async function getSurvey(args: { safetyControlSurveyId: number }): Promise<SafetyControlSurveyView> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveys/getSurvey",
			method: "POST",
			data: {
				safetyControlSurveyId: args.safetyControlSurveyId,
			},
		});
		return response as SafetyControlSurveyView;
	}
}
